/* eslint-disable react/jsx-key */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-nested-ternary */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable array-callback-return */
/* eslint-disable no-empty */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */

import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';

import Loader from '../../../Loader';

import { CardInfo, Container, Divider } from './styles';
import TicketingService from '../../../../services/ticketing';

interface IRestrictions {
  selectedPayment?: string;
}

const Restrictions: React.FC<IRestrictions> = ({ selectedPayment }) => {
  const [loading, setLoading] = useState(false);

  const [paymentMethods, setPaymentMethods] = useState<any[]>([]);

  const services = { ticketingService: new TicketingService() };

  const getPaymentMethods = useCallback(async () => {
    try {
      setLoading(true);

      const response = await services.ticketingService.getBoletoLimit();

      const results = response?.data?.results || [];

      const filteredPaymentMethods = results.filter(
        (payment: any) => payment.payment_type === selectedPayment,
      );

      setPaymentMethods(filteredPaymentMethods);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  }, [selectedPayment]);

  useEffect(() => {
    getPaymentMethods();
  }, []);

  if (loading) {
    return <Loader />;
  }

  return (
    <Container>
      {paymentMethods.map(payment => (
        <CardInfo>
          <div className="limit-header">* Restrições de Recarga:</div>
          <p>Valor mínimo: R$ {String(payment.minimum).replace('.', ',')}</p>

          <p>Valor máximo: R$ {String(payment.maximum).replace('.', ',')}</p>
        </CardInfo>
      ))}
    </Container>
  );
};

export { Restrictions };
